export type Option<T = string> = {
  label: string;
  value: T;
};
